(function(){
  'use strict';

  if(window._alcInit) return;
  window._alcInit = true;

  /* ═══════════ VIDEO ═══════════ */
  function initVideos(){
    document.querySelectorAll('.alc-video__yt-vm').forEach(function(box){
      var btn = box.querySelector('.alc-video__play');
      if(!btn) return;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var url = box.getAttribute('data-url');
        if(!url) return;
        var src = '';
        var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        if(yt) src = 'https://www.youtube.com/embed/'+yt[1]+'?autoplay=1&rel=0';
        var vm = url.match(/vimeo\.com\/(\d+)/);
        if(vm) src = 'https://player.vimeo.com/video/'+vm[1]+'?autoplay=1';
        if(!src) return;
        var f = document.createElement('iframe');
        f.src = src;
        f.setAttribute('frameborder','0');
        f.setAttribute('allow','autoplay; fullscreen; picture-in-picture');
        f.setAttribute('allowfullscreen','');
        box.appendChild(f);
        box.classList.add('is-playing');
      });
    });
  }

  /* ═══════════ SLIDERS ═══════════ */
  function initSliders(){
    document.querySelectorAll('.alc-slider').forEach(function(slider){
      var track = slider.querySelector('.alc-slider__track');
      var prev = slider.querySelector('.alc-slider__arr--l');
      var next = slider.querySelector('.alc-slider__arr--r');
      if(!track||!prev||!next) return;

      var slides = Array.from(track.querySelectorAll('.alc-slider__slide'));
      if(!slides.length) return;
      var idx = 0;

      function pv(){
        var w = window.innerWidth;
        if(w<=480) return 1;
        if(w<=768) return 2;
        if(w<=1024) return 3;
        return 4;
      }
      function sw(){
        var gap = parseFloat(getComputedStyle(track).gap)||20;
        return slides[0].offsetWidth + gap;
      }
      function mi(){ return Math.max(0, slides.length - pv()); }
      function upd(){
        track.style.transform = 'translateX(-'+idx*sw()+'px)';
        prev.style.opacity = idx<=0?'0.3':'1';
        prev.style.pointerEvents = idx<=0?'none':'auto';
        next.style.opacity = idx>=mi()?'0.3':'1';
        next.style.pointerEvents = idx>=mi()?'none':'auto';
      }

      prev.addEventListener('click', function(){ if(idx>0){idx--;upd();} });
      next.addEventListener('click', function(){ if(idx<mi()){idx++;upd();} });

      var sx=0,ex=0,sw2=false;
      track.addEventListener('touchstart',function(e){sx=e.changedTouches[0].screenX;sw2=true;},{passive:true});
      track.addEventListener('touchmove',function(e){if(sw2)ex=e.changedTouches[0].screenX;},{passive:true});
      track.addEventListener('touchend',function(){
        if(!sw2)return;sw2=false;
        var d=sx-ex;
        if(Math.abs(d)>50){
          if(d>0&&idx<mi())idx++;
          else if(d<0&&idx>0)idx--;
          upd();
        }
      },{passive:true});

      var rt;
      window.addEventListener('resize',function(){
        clearTimeout(rt);
        rt=setTimeout(function(){if(idx>mi())idx=mi();upd();},200);
      });
      upd();
    });
  }

  /* ═══════════ ANIMATIONS ═══════════ */
  function initAnim(){
    var els = document.querySelectorAll('.alc-hero, .alc-sec, .alc-banner, .alc-video');
    if(!els.length) return;
    els.forEach(function(el){ el.classList.add('alc-anim'); });
    if('IntersectionObserver' in window){
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ e.target.classList.add('is-vis'); obs.unobserve(e.target); }
        });
      },{threshold:0.08, rootMargin:'0px 0px -40px 0px'});
      els.forEach(function(el){ obs.observe(el); });
    } else {
      els.forEach(function(el){ el.classList.add('is-vis'); });
    }
  }

  /* ═══════════ SMOOTH SCROLL ═══════════ */
  function initSmooth(){
    document.querySelectorAll('.alc-page a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id = this.getAttribute('href');
        if(id==='#') return;
        var t = document.querySelector(id);
        if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); }
      });
    });
  }

  /* ═══════════ FLIPPINGBOOK SCROLL FIX ═══════════ */
  function initFlippingBook(){
    document.querySelectorAll('.flippingbook-wrapper').forEach(function(wrapper){
      var overlay = wrapper.querySelector('.fb-overlay');
      if(!overlay) return;
      overlay.addEventListener('click', function(){
        overlay.style.display = 'none';
      });
      wrapper.addEventListener('mouseleave', function(){
        overlay.style.display = 'block';
      });
      overlay.addEventListener('touchstart', function(){
        overlay.style.display = 'none';
      }, {passive: true});

      wrapper.addEventListener('touchend', function(){
        setTimeout(function(){
          overlay.style.display = 'block';
        }, 3000);
      }, {passive: true});
    });
  }

  function hookKlaviyoToAppForm(){
    var appWidget = document.querySelector('.elfsight-sapp-8ea48501-0076-4ba7-8ffd-d498d34615ef');
    if(!appWidget) return;

    var observer = new MutationObserver(function(){

      var submitDiv = appWidget.querySelector('[eapps-link="buttonSubmit"]');
      if(!submitDiv) return;
      if(submitDiv.dataset.klaviyoHooked) return;

      submitDiv.dataset.klaviyoHooked = 'true';
      submitDiv.addEventListener('click', function(){
        setTimeout(function(){

          var appForm = appWidget.querySelector('form.eapps-form-form');
          if(!appForm) return;

          // ── Exact field names se data lo ──
          var firstNameEl = appForm.querySelector('input[name="first-name-0"]');
          var surnameEl   = appForm.querySelector('input[name="surname-1"]');
          var emailEl     = appForm.querySelector('input[name="email-2"]');
          var companyEl   = appForm.querySelector('input[name="company-3"]');
          var addressEl   = appForm.querySelector('input[name="shipping-address-4"]');
          var projectEl   = appForm.querySelector('.eapps-form-element-input-dropdown');

          var firstName   = firstNameEl ? firstNameEl.value.trim() : '';
          var surname     = surnameEl   ? surnameEl.value.trim()   : '';
          var email       = emailEl     ? emailEl.value.trim()     : '';
          var company     = companyEl   ? companyEl.value.trim()   : '';
          var address     = addressEl   ? addressEl.value.trim()   : '';
          var projectType = projectEl   ? projectEl.value          : '';

          if(projectType === 'Choose type') projectType = '';

          if(!email){
            return;
          }

          var isAD = (
            projectType === 'Commercial' ||
            projectType === 'Multi-residential' ||
            projectType === 'Hospitality'
          );

          // ── KLAVIYO ──
          if(window._learnq){
            window._learnq.push(['identify', {
              '$email':             email,
              '$first_name':        firstName,
              '$last_name':         surname,
              'Company':            company,
              'Shipping Address':   address,
              'Project Type':       projectType,
              'Is AD':              isAD,
              'Lead Source':        'Alchemy Trade Register Form'
            }]);

            window._learnq.push(['track', 'Alchemy Sample Request', {
              'First Name':         firstName,
              'Surname':            surname,
              'Email':              email,
              'Company':            company,
              'Shipping Address':   address,
              'Project Type':       projectType,
              'Is AD':              isAD
            }]);

            console.log('Klaviyo — Data sent');

          } else {
            console.log('Klaviyo (_learnq) not found');
          }

        }, 200); 
      }); 
    }); 
    observer.observe(appWidget, { childList: true, subtree: true });
  }

  /* ══════════════════════════════════════════════ */
  /*  OLD FORM HANDLERS                            */
  /* ══════════════════════════════════════════════ */
  function initForm(){
    document.querySelectorAll('.alc-form').forEach(function(form){
      form.addEventListener('submit', function(e){
        var act = form.getAttribute('action');
        if(!act||act==='#'){
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          if(btn){
            var orig = btn.textContent;
            btn.textContent = 'REQUEST SENT ✓';
            btn.disabled = true;
            btn.style.opacity = '.6';
            setTimeout(function(){
              btn.textContent=orig;
              btn.disabled=false;
              btn.style.opacity='1';
              form.reset();
            },3000);
          }
        }
      });
    });
  }

  /* ═══════════ INIT ═══════════ */
  function init(){
    initVideos();
    initSliders();
    initAnim();
    initForm();
    hookKlaviyoToAppForm()
    initSmooth();
    initFlippingBook();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();